import { useMemo } from 'react';
import { useSessionAreaName, useSessionCollectionName } from '@/platform-services/session';
import { useAreasSelector } from '@/store/selectors';
import { useFindAreasForCollection } from '@/platform-services/areas';
export const useIsActiveAreaValid = () => {
    const activeCollection = useSessionCollectionName();
    const activeArea = useSessionAreaName();
    const areas = useAreasSelector();
    const findAreasForCollection = useFindAreasForCollection();
    return useMemo(() => {
        const areasForCollection = findAreasForCollection(activeCollection, areas);
        return areasForCollection.some((area) => area.name === activeArea);
    }, [activeArea, activeCollection, areas, findAreasForCollection]);
};
